import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import T from 'i18n-react';

import { formatWithoutZeroMinutes, getSaleTime, periodMatcher } from 'Utilities/dateHelpers/dateHelpers';

import { HOUR_MINUTES, LAST_30_MIN_MINUS_ONE, LAST_HOUR_MINUS_ONE, LAST_MIN } from '../saleTimeConsts';

import styles from './Time.module.scss';

T.setTexts(require('Components/texts.json'));

const Time = ({ colour, millisecondsRemaining }) => {
	const colorPeriods = [LAST_30_MIN_MINUS_ONE, LAST_MIN];
	const periods = [LAST_HOUR_MINUS_ONE, ...colorPeriods];

	return (
		<span
			suppressHydrationWarning
			className={cx(styles.time, {
				[styles[colour]]: colorPeriods.find(periodMatcher(millisecondsRemaining)),
				[styles.narrow]: periodMatcher(millisecondsRemaining, LAST_MIN),
			})}
		>
			{getSaleTime({
				calculateFormat: formatWithoutZeroMinutes,
				defaultFormat: HOUR_MINUTES,
				millisecondsRemaining,
				periods,
			})}
		</span>
	);
};

Time.propTypes = {
	colour: PropTypes.oneOf(['red', 'green']).isRequired,
	millisecondsRemaining: PropTypes.number.isRequired,
};

export default Time;
